module.exports = __webpack_public_path__ + "img/boxnet.6787cded.png";